import { DatePipe } from "@angular/common";
import { Component, OnInit, Renderer2 } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { GlobalService } from "src/app/services/global.service";
import Swal from "sweetalert2";
import * as SecureLS from "secure-ls";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import Math from "exact-math";
const Excel = require("exceljs");
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { CommonService } from "src/app/services/common.service";
import { StorageService } from "../../services/storage.service";
@Component({
  selector: "app-camera",
  templateUrl: "./camera.component.html",
  styleUrls: ["./camera.component.css"],
})
export class CameraComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  roleID = this.storageService.getRole();
  userID = this.ls.get("createdBy");
  active = 1;
  alphaPattern = "[a-zA-Z .,]*";
  CameraForm: FormGroup;
  showLoadMore = false;
  page: number = 1;
  page_size: number = 10;
  submitted = false;
  ippattern =
    "(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)";
  manualUpdate = true;
  swal: any;
  total_count = 0;
  camcreate: any;
  cameraList: any[];
  getcamera: any;
  editcamera: any;
  is_active = false;
  deletecamera: any;
  editstatus = false;
  camupdate: any;
  camstatusupdate: any;
  editid: any;
  editbut: boolean;
  isactiveswitch: any;
  page_count = [];
  pageshow = true;
  htmlpageshow: boolean;
  cameraip: any;
  total: number;
  p: number;
  pagedItems: any[];
  writehide = false;
  writeaccess = this.ls.get("write_access");
  camerapattern = "\b((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(.|$)){4}\b";
  searchForm: FormGroup;
  filtervalues: boolean;
  chiparray: any[];
  selectedFiles: any;
  view_File_name: any;
  bulk_form: FormGroup;
  bulkcreate: Object;
  entryFields: boolean = false;
  createNew: boolean = true;
  backendValidationErrors: null;
  cameraid: any;
  camname: any;
  constructor(
    private storageService: StorageService,
    private modalService: NgbModal,
    public router: Router,
    private fb: FormBuilder,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService,
    private renderer: Renderer2,
    public fileupload: CommonService
  ) {}

  async ngOnInit() {
    this.searchForm = this.fb.group({
      id: [""],
      camip: [""],
      camName: [""],
    });
    this.CameraForm = this.fb.group({
      id: [""],
      device_ip: ["", [Validators.required]],
      device_name: ["", [Validators.required]],
      is_active: [""],
    });

    this.bulk_form = this.fb.group({
      bulk_file: [""],
    });

    this.CameraForm.valueChanges.subscribe((data)=>{
      this.backendValidationErrors = null;
    })

    this.page = 1;
    if (this.ls.get("write_access") == 0) {
      this.writehide = true;
    }
    await this.getCamera();
    await this.getPage(this.page, true);
  }

  openField() {
    this.entryFields = true;
    this.createNew = false;
    this.CameraForm.reset();
    this.submitted = false;
  }

  onActiveTab(active) {
    if (active !== 1) {
      this.bulk_form.controls["bulk_file"].patchValue("");
    }
  }

  cancelFields(isEditbut?) {
    this.renderer.removeClass(document.body, "modal-open");
    this.entryFields = false;
    this.CameraForm.reset();
    this.createNew = true;
    if (isEditbut) {
      this.editbut = false;
    }
  }

  async getPage(page: number, disableCall: boolean) {
    this.page = page;
    if(!disableCall) {
      await this.getCamera();
    }
    const res = await this.serverCall(this.cameraList, page);
    this.total = this.total_count;
    this.p = page;

    this.pagedItems = res;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = this.page_size;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }
  get forms() {
    return this.CameraForm.controls;
  }
  get forms1() {
    return this.searchForm.controls;
  }

  async createCamera(form: FormGroup) {
    this.submitted = true;

    if (this.CameraForm.invalid) {
      return;
    }
    this.spinner.show();
    if (form.value.device_name.trim() == "") {
      Swal.fire(
        "Warning!",
        "Please Provide Valid Camera Device Name",
        "warning"
      );
    } else {
      const inputData = {
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        device_ip: form.value.device_ip,
        device_name: form.value.device_name,
        is_active: this.isactiveswitch
          ? this.isactiveswitch == true
            ? "1"
            : "0"
          : "0",
      };

      this.camcreate = await this.globalService.create(
        "camera/create",
        inputData
      );

      if (this.camcreate["status"] === 200) {
        Swal.fire("Success!", this.camcreate["message"], "success");

        this.pageshow = true;
        this.getCamera();
        this.reset();
        this.bulk_form.reset();
        this.entryFields = false;
        this.createNew = true;
        this.backendValidationErrors = null;
        this.renderer.removeClass(document.body, 'modal-open')
      } else if (this.camcreate["status"] === 422) {
        this.backendValidationErrors = this.camcreate?.error["content"];
      } else {
        this.cancelFields();
        this.backendValidationErrors = null;
      }
    }
    
    this.spinner.hide();
  }
  openScrollableContent(longContent) {
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
    }
  }
  Filter(cameraip, camname) {
    this.filtervalues = true;
    this.chiparray = [];
    if (this.cameraip != undefined && this.cameraip != "") {
      this.chiparray.push("Camera IP :" + " " + this.cameraip);
    }
    if (this.camname != undefined && this.camname != "") {
      this.chiparray.push("Camera Name :" + " " +  this.camname);
    }
    this.cameraip = cameraip;
    this.camname = camname;

    if (cameraip == null || cameraip == "") {
      this.pageshow = true;
      this.page = 1;
      this.getCamera();
    } else if (cameraip != null) {
    let camera_check = new RegExp(
      "((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(.|$)){4}"
    );
    let validate_ip = camera_check.test(cameraip);
    if (validate_ip === true) {
      this.cameraip = cameraip;
      this.pageshow = true;
      this.page = 1;
      this.getCamera();
    } else {
      this.filtervalues = false;
      Swal.fire("Warning", "Please Provide the Valid IP", "warning");
      return false;
    }
  }
  }
  res() {
    this.filtervalues = false;
    this.cameraip = null;
    this.camname = null;
    this.searchForm.reset();
    this.pageshow = true;
    this.page = 1;
    this.getCamera();
  }

  async getCamera() {
    this.spinner.show();
    if (this.page === 1) {
      this.cameraList = [];
    }

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      page: this.page,
      role_id: this.storageService.getRole(),
      device_ip: this.cameraip ? this.cameraip : "",
      device_name: this.camname ? this.camname : "",
      page_size: this.page_size,
    };

    this.getcamera = await this.globalService.get("camera/list", filter);

    if (this.getcamera["status"] === 200) {
      this.total_count = this.getcamera["content"].count;
      if (this.getcamera["content"]["rows"].length < this.page_size) {
        this.showLoadMore = true;
      }
      this.cameraList = this.getcamera["content"]["rows"];

      if (this.pageshow === true) {
        this.page_count = [];
        let page_count = Math.ceil(this.total_count / this.page_size);
        if (page_count > 1) {
          this.htmlpageshow = true;
        } else {
          this.htmlpageshow = false;
        }
      }
    } else {
      this.htmlpageshow = false;
      this.showLoadMore = true;
      this.spinner.hide();
    }

    (error) => {
      this.cameraList = [];
      this.spinner.hide();
      this.showLoadMore = true;
    };

    this.spinner.hide();
  }
  editCamera(id, device_ip, device_type) {
    this.spinner.show();
    Swal.fire({
      title: "Edit ?",
      text: "Are you sure you want to edit this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        this.spinner.show();
        this.openField();
        this.active = 2;
        this.editbut = true;
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
          device_ip: device_ip,
        };

        this.editcamera = await this.globalService.get("camera/get", filter);
        let comp_details = this.editcamera["content"];

        if (this.editcamera["status"] === 200) {
          this.CameraForm.controls["id"].setValue(comp_details.id);
          this.CameraForm.controls["device_ip"].setValue(
            comp_details.device_ip
          );
          this.CameraForm.controls["device_name"].setValue(
            comp_details.device_name
          );

          this.editid = comp_details.id;
          this.editstatus = comp_details.is_active;
        }
      } else {
        this.cancelFields();
      }
      this.spinner.hide();
    });
    this.spinner.hide();
  }
  reset() {
    this.submitted = false;
    this.CameraForm.reset();
    this.editstatus = false;
    this.isactiveswitch = false;
  }

  loadMore(index) {
    this.pageshow = true;
    this.page = index;
    this.getCamera();
  }
  previous() {
    this.pageshow = true;
    this.page = this.page - 1;
    this.getCamera();
  }
  next() {
    this.pageshow = true;
    this.page = this.page + 1;
    this.getCamera();
  }

  CameraStatusUpdate(value: boolean, id) {
    this.spinner.show();
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to Change Status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let status;
        this.manualUpdate = value;
        if (value == false) {
          status = "0";
        } else if (value == true) {
          status = 1;
        }
        const inputData = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id ? id : this.editid,
          is_active: status,
        };
        this.camstatusupdate = await this.globalService.update(
          "camera/update/status",
          inputData
        );
        if (this.camstatusupdate["status"] === 200) {
          Swal.fire("Success!", this.camstatusupdate["message"], "success");
          this.pageshow = true;
          this.getCamera();
        }
        if (this.camstatusupdate["status"] != 200) {
          this.pageshow = true;
          this.getCamera();
        }
        this.is_active = status;
      } else {
        this.pageshow = true;
        this.getCamera();
      }
    });
    this.spinner.hide();
  }
  switch(e) {
    this.isactiveswitch = e;
  }

  async updateCamera(form: FormGroup) {
    this.submitted = true;

    if (this.CameraForm.invalid) {
      return;
    }
    this.spinner.show();
    if (form.value.device_name.trim() == "") {
      Swal.fire(
        "Warning!",
        "Please Provide Valid Camera Device Name",
        "warning"
      );
    } else {
      const inputData = {
        id: form.value.id,
        vendor_id: this.ls.get("vendor_id"),
        is_active: this.is_active ? this.is_active : this.editstatus,
        user_id: this.ls.get("createdBy"),
        device_ip: form.value.device_ip,
        device_name: form.value.device_name,
      };
      this.camupdate = await this.globalService.update(
        "Camera/update",
        inputData
      );

      if (this.camupdate["status"] === 200) {
        Swal.fire("Success!", this.camupdate["message"], "success");
        this.pageshow = true;
        this.getCamera();
        this.editbut = false;
        this.reset();
        this.entryFields = false;
        this.createNew = true;
        this.backendValidationErrors = null;
        this.renderer.removeClass(document.body, 'modal-open')
      } else if (this.camupdate["status"] === 422) {
        this.backendValidationErrors = this.camupdate?.error["content"];
      } else {
        this.cancelFields();
        this.backendValidationErrors = null;
      }
    }
    this.spinner.hide();
  }

  async deleteCamera(id, device_ip) {
    this.spinner.show();
    Swal.fire({
      title: "Delete ?",
      text: "Are you sure you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
          device_ip: device_ip,
        };
        this.deletecamera = await this.globalService.delete(
          "camera/delete",
          filter
        );
        if (this.deletecamera["status"] === 200) {
          this.cameraList = [];
          Swal.fire("Success!", this.deletecamera["message"], "success");
          this.pageshow = true;
          this.getCamera();
        }
      }
    });
    this.spinner.hide();
  }

  resetbulk() {
    this.bulk_form.reset();
  }

  formAddReset() {
    this.CameraForm.reset();
    this.editbut = false;
    this.bulk_form.reset();
  }
  formUpdateReset() {
    this.CameraForm.controls["id"].setValue(this.editcamera["content"].id);
    this.CameraForm.controls["device_ip"].setValue(
      this.editcamera["content"].device_ip
    );
    this.CameraForm.controls["device_name"].setValue(
      this.editcamera["content"].device_name
    );
    this.CameraForm.reset();
    this.CameraForm.get("id").setValue(this.editcamera["content"].id);
  }

  async downloadSampleTemplate() {
    this.spinner.show();
    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");
    worksheet.getCell("A1").value = "Sno";
    worksheet.getCell("B1").value = "device_ip";
    worksheet.getCell("C1").value = "device_name";
    worksheet.getCell("A2").value = "1";
    worksheet.getCell("B2").value = "172.20.1.4";
    worksheet.getCell("C2").value = "CAMERA_009";

    for (let i = 2; i < 2500; i++) {
      worksheet.getCell(`D${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        showInputMessage: false,
        formulae: ["$J$1:$J$1048576"],
      };
    }

    worksheet.getColumn(1).width = 20;
    worksheet.getColumn(2).width = 20;
    worksheet.getColumn(3).width = 20;
    worksheet.getColumn(4).width = 20;
    worksheet.getColumn(5).width = 20;
    worksheet.getColumn(6).width = 20;

    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "Camera Sample List" + ".xlsx");
    });
    this.spinner.hide();
  }

  selectFile(event) {
    this.selectedFiles = event.target.files;
    this.view_File_name = this.selectedFiles.item(0).name;
  }

  async BulkUpload(form: FormGroup) {
    if (
      form.value.bulk_file === null ||
      form.value.bulk_file === undefined ||
      form.value.bulk_file === ""
    ) {
      Swal.fire("", "Please upload the file", "error");
    }
    let dataExport = [];
    let file;
    let files;

    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(this.selectedFiles[0]);
    if (this.selectedFiles != null) {
      const file = this.selectedFiles.item(0);

      if (
        file.type !== "application/vnd.ms-excel" &&
        file.type !==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        file.type !== "application/vnd.oasis.opendocument.spreadsheet"
      ) {
        this.spinner.hide();
        Swal.fire("Error!", "Only Excel files are allowed", "error");
        return;
      }

      if (file.size > 2097152) {
        Swal.fire("Warning!", "File Size Must be under 2 MB", "warning");
        return false;
      }
      if (
        file.type == "application/vnd.ms-excel" ||
        file.type ==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type == "application/vnd.oasis.opendocument.spreadsheet"
      ) {
        let formdata = new FormData();
        formdata.append("file", file);
        formdata.append("user_id", this.ls.get("createdBy"));
        formdata.append("vendor_id", this.ls.get("vendor_id"));
        formdata.append("upload_role_id", "4");
        formdata.append("role_id", String(this.storageService.getRole()));
        formdata.append("requester_type", "web");

        this.spinner.show();
        reader.onload = async (e: any) => {
          /* create workbook */ const binarystr: string = e.target.result;
          const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: "binary" });

          /* selected the first sheet */ const wsname: string =
            wb.SheetNames[0];
          const ws: XLSX.WorkSheet = wb.Sheets[wsname];
          /* save data */

          const data = XLSX.utils.sheet_to_json(ws);

          if (data.length > 100) {
            this.spinner.hide();
            Swal.fire(
              "Warning!",
              "Records more than 100 not be allowed",
              "warning"
            );

            return;
          } else {
            this.bulkcreate = await this.globalService.update(
              "camera/upload/excel",
              formdata
            );
            if (this.bulkcreate["status"] === 200) {
              let bulk = this.bulkcreate["content"];
              const expectedHeaders = ["device_ip", "device_name"];
              const missingDataRows = bulk.filter((row) => {
                return expectedHeaders.some((header) => !row[header]);
              });
              if (missingDataRows.length > 0) {
                Swal.fire(
                  "Warning!",
                  "Some rows are missing data for required headers. Please check the file.",
                  "warning"
                );
              } else {
                for (let i = 0; i < bulk.length; i++) {
                  dataExport.push({
                    Sno: i + 1,
                    device_ip: bulk[i].device_ip,
                    device_name: bulk[i].device_name,
                    message: bulk[i].message,
                  });
                }

                var a = await this.fileupload.exportExcel(
                  dataExport,
                  "camera List"
                );
                Swal.fire("Success!", this.bulkcreate["message"], "success");
                await this.getCamera();
                this.pageshow = true;
                this.bulk_form.reset();
              }
            }
            this.spinner.hide();
            this.cancelFields();
          }
        };
      }
    }
  }
  paginationCount(value) {
    this.page = 1;
    if (value >= 5) {
      this.page_size = value;
    }
    this.getCamera();
  }
}
